// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2LzVT","rootCenter":"LoadMoreObserver_rootCenter__3H0W2","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3KDhP"};